import { render, staticRenderFns } from "./NewCloseSingleDay.vue?vue&type=template&id=812d2f66&scoped=true"
import script from "./NewCloseSingleDay.vue?vue&type=script&lang=js"
export * from "./NewCloseSingleDay.vue?vue&type=script&lang=js"
import style0 from "./NewCloseSingleDay.vue?vue&type=style&index=0&id=812d2f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812d2f66",
  null
  
)

export default component.exports